<div class="document">
    <div class="header-section">
        <h1>FAQ</h1>
    </div>

    <p class="faq-heading">How do I personalize my app to display my company logo, description, location and hours of operation?</p>
    <p>Information regarding company logo, description, location and hours can be set by logging into the portal and clicking the category “Org Info”.</p>

    <p class="faq-heading">How do I change the appearance or design of my app?</p>
    <p>The color pallet of the app can be changed by selecting the “Themes” category and selecting a theme. The app top and bottom bar, as long with the accent
        color will change, depending on the theme selected.</p>

    <p class="faq-heading">How can I make sure my images will show up correctly in the app?</p>
    <p>When uploading images for various categories such as Organization Info, Sponsors, News or Events, a minimum or recommended size will be displayed under
        the upload window.</p>

    <p class="faq-heading">My event is showing up in the calendar but not in the newsfeed, why?</p>
    <p>In order for events to display within the newsfeed, the options “Publish” and “Display in News Feed” must be check marked.</p>

    <p class="faq-heading">Social Media posts are not displayed chronologically in the newsfeed – why?</p>
    <p>News and events created by the club or organization are prioritized to be displayed 72 hours ahead of social media posts. This will cause the order of FB
        and Twitter post to be non-standard.</p>

    <p class="faq-heading">How do I create or edit a "User Type" in the portal?</p>
    <p>Go to "Users" tab and click on the button "User Type" on the top right-hand side.</p>

    <p class="faq-heading">Can I edit user information in the portal? How?</p>
    <p>Yes, user info can be edited by selecting a member within the “Users” tab. From there, click “Edit” and then “Save” once all modifications are
        made.</p>

    <p class="faq-heading">How do I create guest access for non-members?</p>
    <p>From the content management portal, go to the Users tab. Click on “Add” to begin creating a guest account. The fields “first name” and “last name” can
        be anything desired, but the “email” field must be of the format guest@xxx.com. For example, the email guest@sampleclub.com . Once the guest email is
        created, the password is automatically set to “guest” and the account is ready for use.</p>

    <p class="faq-heading">How do I create a “sub-album”</p>
    <p>First go to the Album under which you want to create a sub-album. Sub-albums can be created by clicking the button to the right of an album labeled
        “Add sub-album”.</p>

    <p class="faq-heading">When I upload my image nothing happens?</p>
    <p>Please verify the image type you are trying to upload. Currently the my1218app portal only supports PNG, JPG and BMP that are no larger than 4MB.</p>

    <p class="faq-heading">What is the cancellation policy?</p>
    <p>Terms and conditions can be found by clicking on the "Terms and Cond." link at the bottom left of this site.</p>
</div>
